import React, { createContext, useContext, useState, useCallback } from 'react'

const SystemMessagesContext = createContext()

export const useSystemMessages = () => {
    const context = useContext(SystemMessagesContext)
    if (!context) {
        throw new Error('useSystemMessages must be used within SystemMessagesProvider')
    }
    return context
}

export const SystemMessagesProvider = ({ children }) => {
    const [message, setMessage] = useState(null)

    const showMessage = useCallback((content, type = 'info', options = {}) => {
        setMessage({
            content,
            type,
            dismissible: options.dismissible !== false,
            leftSide: options.leftSide || null,
            rightSide: options.rightSide || null,
            id: Date.now(),
        })
    }, [])

    const showInfo = useCallback(
        (content, options = {}) => {
            showMessage(content, 'info', options)
        },
        [showMessage]
    )

    const showError = useCallback(
        (content, options = {}) => {
            showMessage(content, 'error', options)
        },
        [showMessage]
    )

    const showSuccess = useCallback(
        (content, options = {}) => {
            showMessage(content, 'success', options)
        },
        [showMessage]
    )

    const clearMessage = useCallback(() => {
        setMessage(null)
    }, [])

    const value = {
        message,
        showMessage,
        showInfo,
        showError,
        showSuccess,
        clearMessage,
    }

    return <SystemMessagesContext.Provider value={value}>{children}</SystemMessagesContext.Provider>
}
